<div class="modal-header">
  <h4 id="copy-acquisition-sessions-from-another-image-modal" class="modal-title">
    {{ "Copy from another image" | translate }}
  </h4>

  <button (click)="modal.dismiss()" class="close" aria-describedby="modal-title" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <form [formGroup]="form">
    <formly-form [fields]="fields" [form]="form" [model]="model"></formly-form>
  </form>
</div>

<div class="modal-footer">
  <button (click)="modal.dismiss()" class="btn btn-outline-secondary" type="button">
    {{ "Cancel" | translate }}
  </button>

  <button
    [class.loading]="(loadingService.loading$ | async) || form.pending"
    [disabled]="form.invalid"
    (click)="onCopyClicked()"
    class="btn btn-primary"
    type="button"
  >
    {{ "Copy" | translate }}
  </button>
</div>

<ng-template #imageOptionTemplate let-item="item">
  <div class="image-option-template">
    <div class="row align-items-center">
      <div class="col-2">
        <img [alt]="item.value.title" [src]="getGalleryThumbnail(item.value)" class="w-100" />
      </div>
      <div class="col ps-2">
        <h5 class="title">{{ item.value.title }}</h5>
        <div class="uploaded">
          {{ "Published" | translate }}:
          <abbr *ngIf="!!item.value.published; else unpublishedTemplate" [title]="item.value.published | localDate">
            {{ item.value.published | localDate | timeago }}
          </abbr>

          <ng-template #unpublishedTemplate>
            <span class="text-muted">{{ "Unpublished" | translate }}</span>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</ng-template>
